import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/services/TeamSection.css';

const TeamSection = () => {
  // Team Members Data
  const teamMembers = [
    {
      id: 1,
      name: 'Stephen Michael',
      role: 'Wedding Planner',
      image: 'https://designingmedia.com/bridely/wp-content/uploads/2024/01/team-img-1.jpg',
      bgColor: '#8ec5be'
    },
    {
      id: 2,
      name: 'Felicitas Creager',
      role: 'Conference Planner',
      image: 'https://designingmedia.com/bridely/wp-content/uploads/2024/01/team-img-2.jpg',
      bgColor: '#8ec5be'
    },
    {
      id: 3,
      name: 'Alisha Rees',
      role: 'Catering Manager',
      image: 'https://designingmedia.com/bridely/wp-content/uploads/2024/01/team-img-3.jpg',
      bgColor: '#8ec5be'
    }
  ];

  return (
    <section className="team-section">
      <Container>
        {/* Section Header */}
        <Row className="justify-content-center mb-5">
          <Col xs={12} lg={10} xl={8}>
            <div className="team-header text-center">
              <p className="team-subtitle">
                Meet Our Talented Team
              </p>
              <h2 className="team-main-heading">
                Meet the Experts Behind Your Dream Wedding
              </h2>
            </div>
          </Col>
        </Row>

        {/* Team Members Cards */}
        <Row className="justify-content-center g-4">
          {teamMembers.map((member) => (
            <Col 
              xs={12} 
              sm={6} 
              md={6} 
              lg={4} 
              key={member.id}
              className="d-flex justify-content-center"
            >
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="team-member-image"
                  />
                  <div 
                    className="team-info-overlay"
                    style={{ backgroundColor: member.bgColor }}
                  >
                    <h3 className="team-member-name">
                      {member.name}
                    </h3>
                    <p className="team-member-role">
                      {member.role}
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TeamSection;